const defaultValues = {
  savedColors: [],
  saveColor: (hex) => {},
  unsaveColor: (hex) => {},
};
Object.freeze(defaultValues);

export default defaultValues;
